import React, { Component } from "react";
import styled from "styled-components";

import { AnalyticsAggregateType } from "@formant/core/model/AnalyticsAggregateType";
import { spacing5, spacing10 } from "@formant/ui/component/common/Spacing";

import { Scrollable } from "../common/Scrollable";
import { Value } from "../Observe/NumericSet/Value";
import { LoadingChartIndicator } from "./LoadingChartIndicator";

export interface ISummaryValue {
    value: number;
    name?: string;
    type?: AnalyticsAggregateType;
    unit?: string;
}

interface IAnalyticsSummaryChartProps {
    items: ISummaryValue[];
}

export class AnalyticsSummaryChart extends Component<IAnalyticsSummaryChartProps> {
    public render() {
        const { items } = this.props;

        if (items.length === 0) {
            return <LoadingChartIndicator />;
        }

        const values = this.props.items.map(item => (
            <ValuePadding>
                <ValueBanner
                    value={item.value}
                    unit={item.unit}
                    label={
                        item.type
                            ? `${item.type.toUpperCase()}(${item.name})`
                            : item.name || ""
                    }
                    invertedWarning={true}
                    old={false}
                />
            </ValuePadding>
        ));

        return (
            <Scrollable>
                <ValueContainer>{values}</ValueContainer>
            </Scrollable>
        );
    }
}

const ValueContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${spacing10} 0 ${spacing10} 0;
    min-height: 100%;
`;

const ValuePadding = styled.div`
    padding: ${spacing5} 0 ${spacing5} 0;
`;

const ValueBanner = styled(Value)`
    circle:nth-of-type(2) {
        stroke: var(--formant-color-data-green);
    }
`;
